import { IChartThemeColorFeature } from '@tencent/chart-drawer-components/lib/interface';
import { Feature } from '@tencent/workbench';
import { SLIDE_ADAPTER } from '@src/framework/workbench/ssr/slide-adapter';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { findChartColorPaletteById, presetColorPalettes } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/colors';
import { ThemeColorSelectorOption } from '@tencent/chart-drawer-components/lib/config';

@Feature({
    name: 'ChartThemeColorFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartThemeColorFeature,
})
export class ChartThemeColorFeature extends ChartBaseDrawerFeature implements IChartThemeColorFeature {
    /**
     * 设置主题色
     * @param config 主题色下拉框选项列表使用的颜色配置
     */
    public setThemeColor(config?: ThemeColorSelectorOption) {
        if (!config || typeof config !== 'object') return;
        const { id } = config;
        const model = this.getSelectModel();
        const { chartProperty } = model;
        const colorPalette = findChartColorPaletteById(String(id));
        chartProperty.updateChartColors(colorPalette);
    }
}
